import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import IconWarning from '../../assets/icon-warning.svg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { setErrorMessage } from '../../app/store/majesticSlice';

function MessageErrorModal({ message, callAgency, handleCloseModal = () => {} }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const handleClose = () => {
    setShow(false);
    dispatch(setErrorMessage({}));
    handleCloseModal();
  };
  // const handleShow = () => setShow(true);

  useEffect(() => {
    if (message !== '') {
      setShow(true);
    }
  }, [message]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      contentClassName="border-0"
      centered
    >
      <Modal.Header className="pt-3 pb-0 border-0">
        <Modal.Title className="mx-auto text-center">
          <img src={IconWarning} alt="icon-warning" className="pb-3" />
          {!callAgency && <p className="mb-0 app-fw-notosans-bold">{t('TXT_TITLE_NOTICE')}</p>}
          {callAgency && <p className="mb-0 app-fw-notosans-bold">{t('TXT_ERROR_NOT_MATCH_GUEST_TYPE')}</p>}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-1">
        <p className="mb-0 app-txt-granite-80-dark text-center app-fs-15 app-lh-h4">
          {message}
        </p>

        {callAgency && (
          <div className="mt-2">
            <p className="mb-0 app-txt-granite-80-dark text-center app-fs-15 app-lh-h4">
              {t('TXT_WARNING_CALL_AGENCY')}
            </p>
            <p className="mb-0 mt-1 fs-4 app-txt-granite-80-dark app-fw-notosans-bold text-center">
              1-888-477-7227
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 mx-auto">
        <Button
          variant=""
          onClick={handleClose}
          className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height px-4"
        >
          {t('TXT_BTN_ACCEPT')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default MessageErrorModal;
